import { TextFieldSize } from '../text-field';

export class TextFieldGroupConfig {
  horizontal: boolean;
  size: TextFieldSize;

  constructor({
    horizontal = true,
    size = TextFieldSize.Default
  } = {}) {
    this.horizontal = horizontal;
    this.size = size;
  }
}
